<template>
    <div class='main'>
        <div class='content'>
            <h1 class='title is-4'>設定</h1>
            <h1 class='title is-5'>口座情報</h1>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>金融機関名</label>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text"  v-model='setting.account.bank'>
                        </label>
                    </div>
                </div>
            </div>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>支店名</label>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text"  v-model='setting.account.branch'>
                        </label>
                    </div>
                </div>
            </div>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>預金種目</label>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text"  v-model='setting.account.depositItem'>
                        </label>
                    </div>
                </div>
            </div>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>口座番号</label>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text"  v-model='setting.account.number'>
                        </label>
                    </div>
                </div>
            </div>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>口座名義</label>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text"  v-model='setting.account.holder'>
                        </label>
                    </div>
                </div>
            </div>
            <button class='button is-info save' @click='save'>設定を保存</button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Setting',
    components: {
    },
    data () {
        return {
            setting: {
                account: {
                    bank: '',
                    branch: '',
                    depositItem: '',
                    number: '',
                    holder: ''
                }
            }
        }
    },
    mounted () {
        const self = this
        const params = this.$parent.requestParams

        self.axios.get(`${process.env.API_URL}/lab/setting${params}`).then((res) => {
            const setting = res.data.setting

            if (setting && setting.account) self.setting = setting
        }).catch((e) => {
            console.log(e)
            alert('サーバーに問題が発生しています')
        })
    },
    methods: {
        save () {
            const self = this
            const params = this.$parent.requestParams

            self.axios.post(`${process.env.API_URL}/lab/setting${params}`, {
                setting: self.setting
            }).then((res) => {
                if (res.data.message === 'OK') {
                    alert('保存が完了しました')
                } else {
                    throw new Error()
                }
            }).catch((e) => {
                alert('サーバーに問題が発生しています')
            })
        }
    }
}
</script>

<style scoped>

input[type=text] {
    height: 30px;
    width: 200px;
}

.date {
    width: 200px;
}

.margin-l-20 {
    margin-left: 20px;
}

.line-height-40 {
    line-height: 40px;
}

.question-wrapper {
    display: flex;
}

.question {
    margin-left: 10px;
    height: 40px;
    cursor: pointer;
}

.label {
    width: 150px;
}

.fee-label {
    width: 50px;
}

.save {
    float: right;
    margin-top: 40px;
}

.line {
    margin-top: 30px;
    margin-bottom: 20px;
    border-bottom: 2px solid #f5f5f5;
}

.password {
    margin-top: 20px;
}

.fa-question-circle {
    height: 40px;
}

.size-titles {
    width: 320px;
    display: flex;
    height: 30px;
    margin-top: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.size-title, .size {
    width: 160px;
}

.content {
    padding: 25px;
    margin: auto;
    width: 780px;
}

.field-body {
    min-width: 780px;
}

.size-column {
    min-width: 160px;
}

.price-input {
    margin-top: 6px;
    height: 30px;
    width: 80px;
}

@media screen and (max-width: 768px) {

}

@media screen and (min-width: 768px) {
    .size {
        display: flex;
        margin-left: 210px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/lab/pages/Setting.vue